import React from "react";

export interface EventItem {
  date: string;
  municipality: string;
  location: React.ReactNode;
  collab?: React.ReactNode;
}

export const eventItems: EventItem[] = [
  // AKULIINA 24.7.2026
  {
    date: "24.7.2026",
    municipality: "Jämsä",
    location: (
      <a
        href="https://www.akuliina.fi/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Kahvila-ravintola Akuliina
      </a>
    ),
    collab: (
      <>
        <span>{"w / "}</span>
        <a
          href="https://nooralouhimo.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Noora Louhimo
        </a>
      </>
    ),
  },
  // GENERAL WAY 24.7.2026
  {
    date: "29.8.2026",
    municipality: "Jämsänkoski",
    location: (
      <a
        href="https://www.instagram.com/generalwaypub_/"
        target="_blank"
        rel="noopener noreferrer"
      >
        General Way Pub
      </a>
    ),
    collab: (
      <>
        <span>{"w / Sintti ja Pienet Kalat"}</span>
        {/* <a
          href="https://nooralouhimo.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Sintti ja Pienet Kalat
        </a> */}
      </>
    ),
  },
];
